import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { Link, O, Spinner } from "../../../../../features/ui"
import { Delivery, DeliveryOrder } from "../../../state/types"
import { useEffect, useState } from "react"
import { useDeliveryOrderLoaders } from "../../../loaders/deliveryOrderLoaders"
import { deliveryHelpers } from "../../../hooks/deliveryHooks"

type Props = {
    delivery: Delivery
}

export const DeliveryLink = (props: Props) => {
    const { delivery } = props

    const [deliveryOrder, setDeliveryOrder] = useState<O<DeliveryOrder>>()

    const { describeDelivery } = deliveryHelpers
    const { getRoutePath } = useRoutesHooks()

    const deliveryOrderLoaders = useDeliveryOrderLoaders()

    useEffect(() => {
        deliveryOrderLoaders().loadDeliveryOrder(delivery.orderId!).then(setDeliveryOrder)
    }, [delivery.orderId])

    if (!deliveryOrder) return <Spinner centered={false} />

    return (
        <Link
            text={describeDelivery(delivery, deliveryOrder)}
            icon="tags"
            kind="primary"
            to={getRoutePath(RoutePath.DELIVERY_NOTES, delivery.id)}
        />
    )
}
